/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import classnames from 'classnames';
import React from 'react';

import { SensiblyBreakCamelCase } from 'src/app/graph/explorerPage/components/sensiblyBreakCamelCase/SensiblyBreakCamelCase';
import { MatchSegments } from 'src/lib/explainRegexMatch';

export const highlightClass = 'bg-searchhighlight' as const;

export const HighlightedGraphQLName = ({
  name,
  regexResult,
  blackBackground,
  isMatch,
  singleLine,
  className,
}: {
  name: string;
  regexResult: MatchSegments | null | undefined;
  blackBackground?: boolean;
  isMatch?: boolean;
  singleLine?: boolean;
  className?: string;
}) => {
  if (!regexResult || regexResult.every((segment) => !segment.matched)) {
    return (
      <span
        className={classnames(isMatch ? 'bg-green-lightest' : '', className)}
      >
        {singleLine ? name : <SensiblyBreakCamelCase camelCasedString={name} />}
      </span>
    );
  }

  return (
    <>
      {regexResult?.map((segment, i, arr) => (
        <span
          key={arr
            .slice(0, i + 1)
            .map((s) => s.text)
            .join()}
          className={classnames(
            !singleLine && 'inline-block',
            'leading-6',
            (segment.matched || isMatch) &&
              (blackBackground
                ? 'bg-black text-green-lighter'
                : classnames(
                    // eslint-disable-next-line local/no-conditional-class-names
                    highlightClass,
                    'text-inverted',
                  )),
            className,
          )}
          css={css`
            text-decoration-line: inherit;
          `}
        >
          {singleLine ? (
            segment.text
          ) : (
            <SensiblyBreakCamelCase camelCasedString={segment.text} />
          )}
        </span>
      ))}
    </>
  );
};
